const formattedCurrentMonthData = (data) =>
  data.map((d, index) => {
    return {
      id: index + 1,
      AOP: d.AOP,
      M: d.M,
      M1: d.M1,
      M2: d.M2,
      OutletType: d.OutletType,
      Pricelist: d.Pricelist,
      ProductCode: d.ProductCode,
      Product_Name: d.Product_Name,
      Warehouse: d.Warehouse,
      ...d.daily_sales,
    };
  });

const formatUpdatedCurrentMonthData = (data) => {
  if (data) {
    Object.assign(data, data.daily_sales);
    delete data.daily_sales;
  }
  return data;
};

export { formattedCurrentMonthData, formatUpdatedCurrentMonthData };
